import { Helmet } from 'react-helmet';
import type { Product } from '../../bff-api/products/model';

export const VideoSchema = ({ product }: { product?: Product }) => {
    if (product) {
        const { c_videoSchema } = product;

        if (c_videoSchema) {
            return (
                <Helmet>
                    <script type="application/ld+json">
                        {JSON.stringify(c_videoSchema, null, 2)}
                    </script>
                </Helmet>
            );
        }
    }

    return null;
};
